import { useEffect, useRef } from 'react'
import { Mtds } from 'prove-common'
import type { ToolErrors } from './resultsUpload'

export const ToolErrorSummary = ({ errors }: { errors: ToolErrors }) => {
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    if (Object.keys(errors).length) heading.current?.focus()
  }, [errors])
  return (
    <Mtds.Errorsummary hidden={!Object.keys(errors).length}>
      <Mtds.Heading as='h2' data-size='xs' tabIndex={-1} ref={heading}>
        Rett følgende før du fortsetter
      </Mtds.Heading>
      <ul>
        {Object.entries(errors).map(([id, message]) => (
          <li key={id}>
            <a
              href={`#${id}`}
              onClick={(event) => {
                event.preventDefault()
                const field = document.getElementById(id)
                field?.focus()
                field?.scrollIntoView?.({ block: 'center' })
              }}
            >
              {message}
            </a>
          </li>
        ))}
      </ul>
    </Mtds.Errorsummary>
  )
}
